import React, { useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';

import { importDataForSelectedPractices } from 'api/Admin/Practitioner';

import { usePractitionerImportDataContext } from 'lib/context/PractitionerImportDataContext/PractitionerImportDataContext';
import { iaRa } from 'lib/helpers/utility';

import { showAlert } from 'components/shared/Alert/Alert';
import Button from 'components/shared/Buttons/Button';
import Modal from 'components/shared/Modal/Modal';

import DataSelector from './DataSelector';

function hasActiveSelection(importAll, state) {
  return (
    importAll ||
    Object.values(state).some(
      (item) => item.selectAll === true || (Array.isArray(item.data) && item.data.length > 0)
    )
  );
}

const ImportPractitionerDataModal = ({ importDataModalVisible, setImportDataModalVisible }) => {
  const { state, sourcePractice, importAll, targetPractices } = usePractitionerImportDataContext();
  const [loading, setLoading] = useState(false);
  const navigation = useNavigate();
  const { practitionerId } = useOutletContext();

  const handleImportData = async () => {
    if (iaRa(targetPractices).length === 0) {
      showAlert({ message: 'Please select a location to export data to!', color: 'danger' });
      return;
    }

    if (!hasActiveSelection(importAll, state)) {
      showAlert({
        message: 'No selections detected. Please select at least one item.',
        color: 'danger'
      });

      return;
    }

    const params = {
      sourcePractice: sourcePractice?.value,
      targetPractices: targetPractices.map((loc) => loc.value),
      practitioner_id: practitionerId
    };

    if (importAll) {
      params.importAll = true;
    } else {
      params.importAll = false;
      params.data = state;
    }
    setLoading(true);
    const { code } = await importDataForSelectedPractices(navigation, params);
    if (code === 0) {
      setImportDataModalVisible(false);
      showAlert({ message: 'Data imported successfully', color: 'success' });
    }
    setLoading(false);
  };

  return (
    <Modal
      handleOpen={importDataModalVisible}
      handleClose={() => setImportDataModalVisible(false)}
      title="Import Data"
      bodyClassName="p-0"
      customStyling={{ width: '720px' }}
      slideFromRight
      footer={
        <div className="flex w-full justify-between">
          <Button
            outlined
            text="Cancel"
            color="neutral"
            onClick={() => setImportDataModalVisible(false)}
            data-qa="cancel-select-owner-btn"
          />

          <Button
            onClick={handleImportData}
            text="Import Data"
            id="createContactModalBtn"
            data-qa="append-owner-btn"
            loading={loading}
            disabled={!sourcePractice || loading}
          />
        </div>
      }>
      <DataSelector />
    </Modal>
  );
};

export default ImportPractitionerDataModal;
